import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  Tooltip,
} from "@mui/material";
import {
  OutlinedIconFab,
  StyledTableCellHistory,
  StyledTableContainer,
  StyledTableRowHistory,
} from "../StyledComponents";
import Icon from "../Utils/Icons";

export const InvestigationsSimplifiedTable = ({
  data,
  activeSection,
  handleEditRow = () => {},
  handleDeleteRow = () => {},
}) => {
  if (!data || data.length === 0) return null;

  return (
    <>
      {data.length > 0 && (
        <Grid item xs={12} md={6}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistory>
                    Test/Investigation Name
                  </StyledTableCellHistory>

                  <StyledTableCellHistory>
                    Clinical Notes
                  </StyledTableCellHistory>

                  {activeSection && (
                    <StyledTableCellHistory>Actions</StyledTableCellHistory>
                  )}
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {data.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row?.term}
                      {row?.source === "voice" && !row.id && (
                        <Tooltip title="Machine-interpreted text — please verify before confirming">
                          <span className="missing-id-warning">⚠️</span>
                        </Tooltip>
                      )}
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      {row?.clinical_note || "-"}
                    </StyledTableCellHistory>

                    {activeSection && (
                      <StyledTableCellHistory sx={{ display: "flex" }}>
                        <OutlinedIconFab
                          onClick={() => handleEditRow(rowIndex)}
                          sx={{ marginRight: 1 }}
                        >
                          <Icon name="editInTable" size={32} />
                        </OutlinedIconFab>

                        <OutlinedIconFab
                          onClick={() => handleDeleteRow(rowIndex)}
                        >
                          <Icon name="deleteInTable" size={32} />
                        </OutlinedIconFab>
                      </StyledTableCellHistory>
                    )}
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
